import React from 'react';
import { Link } from 'react-router-dom';
import '../../Component/blog.css'; // We'll create this next

const institutes = [
  { id: 'st-pauls', displayName: "St. Paul's Matric Hr Sec School Blogs", instituteName: "St. Paul's Matric Hr Sec School", location: "Pernambut", img: 'school3.jpg' },
  { id: 'st-josephs', displayName: "St. Joseph's Matric Hr Sec School Blogs", instituteName: "St. Joseph's Matric Hr Sec School", location: "Pallalakuppam", img: 'school2.jpg' },
  { id: 'agaram', displayName: 'Agaram Matriculation School Blogs', instituteName: 'Agaram Matriculation School', location: "Pallikonda", img: 'school4.jpg' },
  { id: 'trinity', displayName: 'Trinity Matric Hr Sec School Blogs', instituteName: 'Trinity Matric Hr Sec School', location: "Vellore", img: 'school6.jpg' },
  { id: 'cap-career', displayName: 'Captains Career Campus Blogs', instituteName: 'Captains Career Campus', location: "Pernambut", img: 'school1.jpg' },
  { id: 'nayagi', displayName: 'Nayagi Institute of Nursing Blogs', instituteName: 'Nayagi Institute of Nursing', location: "Pernambut", img: 'school5.jpg' },
];

const Blog = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="Subpage_Hero">
        <div className="container">
          <div className="text-lg-start text-center" data-aos="fade-up">
            <h1>Our Blog</h1>
            <p>
              Explore inspiring stories, updates, and insights from all DNET institutes.
            </p>
          </div>
        </div>
      </section>

      {/* Institutes Grid */}
      <section className="blog-institutes-section">
        <div className="container">
          <div className="row">
            {institutes.map((institute) => (
              <div className="col-lg-4 col-md-6 mb-4" key={institute.id}>
                <Link to={`/blog/${institute.id}`} className="institute-card">
                  <div className="institute-card-inner">
                    <figure>
                      <img
                        src={`/assets/images/School/${institute.img}`}
                        alt={institute.displayName}
                        className="w-100"
                      />
                    </figure>
                    <div className="institute-overlay">
                      <h4>{institute.displayName}</h4>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;